import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import apiService from "../../utils/configAxios";
import { isValidEmail } from "../../utils";
import CookieConsentBanner from "../Reusable/CookieConsentBanner";

const Footer = () => {
  const { t } = useTranslation();
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState("");
  const [newsletterStatusType, setNewsletterStatusType] = useState("");
  const [newsletterSubmitting, setNewsletterSubmitting] = useState(false);

  const submitNewsletter = async (event) => {
    event.preventDefault();
    const email = newsletterEmail.trim();

    if (!isValidEmail(email)) {
      setNewsletterStatus(t("footer.newsletter.invalidEmail"));
      setNewsletterStatusType("error");
      return;
    }

    setNewsletterSubmitting(true);
    setNewsletterStatus("");
    setNewsletterStatusType("");

    try {
      await apiService.post("/api/sales-email-lead/public", { email });
      setNewsletterEmail("");
      setNewsletterStatus(t("footer.newsletter.success"));
      setNewsletterStatusType("success");
    } catch (err) {
      setNewsletterStatus(t("footer.newsletter.error"));
      setNewsletterStatusType("error");
    } finally {
      setNewsletterSubmitting(false);
    }
  };

  return (
    <div className="footer-container">
      <Container>
        <div className="footer-list-items">
          <div className="footer-list-item">
            <h3>{t("footer.quickLinks.title")}</h3>
            <ul>
              <li>
                <Link to="/reels">{t("footer.quickLinks.reel")}</Link>
              </li>
              <li>
                <Link to="/about">{t("footer.quickLinks.about")}</Link>
              </li>
              <li>
                <Link to="/contact-instructor">
                  {t("footer.quickLinks.cooperation")}
                </Link>
              </li>
              <li>
                <Link to="/contact">{t("footer.quickLinks.contact")}</Link>
              </li>
            </ul>
          </div>
          <div className="footer-list-item">
            <h3>{t("footer.support.title")}</h3>
            <ul>
              {/* <li>
                <Link to="/faq">{t("footer.support.faq")}</Link>
              </li> */}
              <li>
                <Link to="/privacy-policy">{t("footer.support.policy")}</Link>
              </li>
              <li>
                <Link to="/terms">{t("footer.support.terms")}</Link>
              </li>
            </ul>
          </div>
          <div className="footer-list-item">
            <h3>{t("footer.social.title")}</h3>
            <div className="social-container">
              <div className="social-item">
                <a
                  href="https://www.instagram.com/katarza.tv/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/images/instagram-2.png" alt="instagram" />
                </a>
              </div>
              <div className="social-item">
                <a
                  href="https://www.youtube.com/@katarza-tv"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/images/youtube.png" alt="youtube" />
                </a>
              </div>
              <div className="social-item">
                <a
                  href="https://www.linkedin.com/company/katarza-tv/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src="/images/linkedin.png" alt="linkedin" />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-list-item">
            <h3>{t("footer.bank.title")}</h3>
            <div className="bank-container-footer">
              <div className="bank-item-footer border-bottom-line">
                <a
                  href="https://www.raiffeisenbank.rs/sr/stanovnistvo.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/raiffeisen-bank-seeklogo.png"
                    alt="Raiffeisen Bank"
                  />
                </a>
              </div>
              <div className="bank-item-footer middle">
                <a
                  href="https://rs.visa.com/run-your-business/small-business-tools/payment-technology/visa-secure.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/visa-secure_blk.png" alt="Mastercard" />
                </a>

                <a
                  href="https://www.mastercard.rs/sr-rs/korisnici/podrska/sigurnost-i-zastita/identity-check.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/mc_idcheck_hrz_rgb_rev.png"
                    alt="Intesa Bank"
                  />
                </a>
              </div>
              <div className="bank-item-footer">
                <img src="/images/lg4.png" alt="lg" />
              </div>
            </div>
          </div>
          <div className="footer-list-item footer-newsletter">
            <h3>{t("footer.newsletter.title")}</h3>
            <p>{t("footer.newsletter.description")}</p>
            <form
              className="footer-newsletter-form"
              onSubmit={submitNewsletter}
              noValidate
            >
              <input
                aria-label={t("footer.newsletter.emailLabel")}
                type="email"
                value={newsletterEmail}
                onChange={(event) => setNewsletterEmail(event.target.value)}
                placeholder={t("footer.newsletter.emailPlaceholder")}
              />
              <button type="submit" disabled={newsletterSubmitting}>
                {newsletterSubmitting
                  ? t("footer.newsletter.submitting")
                  : t("footer.newsletter.submit")}
              </button>
            </form>
            {newsletterStatus && (
              <p
                className={`footer-newsletter-status ${newsletterStatusType}`}
                role={newsletterStatusType === "error" ? "alert" : "status"}
              >
                {newsletterStatus}
              </p>
            )}
          </div>
        </div>
      </Container>
      <CookieConsentBanner />
    </div>
  );
};

export default Footer;
